import React from 'react'
import { Athlete } from '~/domain/Athlete'
import { getAthlete } from '~/services/athletes'

interface UseAthleteReturnType {
  data: Athlete | undefined
  error: unknown | undefined
  isLoading: boolean
  isError: boolean
}

export function useAthlete (trophyId: string | undefined): UseAthleteReturnType {
  const [data, setData] = React.useState<Athlete | undefined>()
  const [error, setError] = React.useState<unknown | undefined>()
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [isError, setIsError] = React.useState<boolean>(false)

  React.useEffect(() => {
    const query = async () => {
      if (!trophyId) return

      try {
        const athlete = await getAthlete(trophyId)

        setData(athlete)
      } catch (exception: unknown) {
        setError(exception)
        setIsError(true)
      } finally {
        setIsLoading(false)
      }
    }

    query()
  }, [trophyId])

  return { data, error, isLoading, isError }
}
